<template>
  <Container type="card-full" v-loading="loading">
    <div class="view-container">
      <div class="view-box">
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目编号</div>
            <div class="view-value">{{ project.projectcode }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">采购人</div>
            <div class="view-value">{{ project.pcomname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">项目名称</div>
            <div class="view-content">{{ project.projectname }}</div>
          </div>
        </div>
        <div class="view-row">
          <div class="view-field">
            <div class="view-label">{{ prsflgName }}单位名称</div>
            <div class="view-value">{{ project.psucomname }}</div>
          </div>
          <div class="view-field">
            <div class="view-label">{{ prsflgName }}金额</div>
            <div class="view-value">￥{{ project.psuamt | qfwVal }}元</div>
          </div>
        </div>
        <div class="split-line"></div>
        <div>
          <el-button type="primary" @click="saveWinningBid">保存</el-button>
          <el-button type="info" @click="viewWinningBid">预览</el-button>
          <el-button type="success" @click="WinningBid">提交</el-button>
          <span
            style="
              color: red;
              padding-left: 30px;
              font-weight: bold;
              font-size: 10px;
            "
            >(请在word里编辑好内容：使用字体：小四、行间距：二倍行距)</span
          >
        </div>
        <div class="split-line"></div>
        <el-form
          ref="ruleForm"
          :model="project"
          label-position="right"
          class="mainfrom"
        >
          <div class="content">
            <el-form-item label="选择模板">
              <div>
                <el-select
                  placeholder="请选择"
                  v-model="tmplchoose"
                  @change="setTmplContent"
                  clearable
                >
                  <el-option
                    v-for="item in templateOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
                <div ref="editorCGNR" style="text-align: left;margin-top:10px;"></div>
              </div>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
  </Container>
</template>
<script>
import request from "@/utils/request";
import E from "wangeditor";
import _ from "lodash";
import config from "../../assets/config";
import utils from "../../assets/js/utils";
import addForm from "../kfgl/addForm.vue";
export default {
  components: { addForm },
  name: "editWinningBid",
  data() {
    return {
      psuid: "",
      loading: false,
      project: {},
      editorCGNR: "",
      editorCGNRContent: "",
      tmplchoose: "",
      templateOptions: [],
    };
  },
  created() {
    this.init();
  },
  filters: {
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value);
      } else {
        return value;
      }
    },
  },
  deactivated() {
    this.$destroy();
  },
  async activated() {
    this.init();
    await this.getProject();
    await this.initEditorCGNR();
    await this.getTemplateOptions();
  },
  computed: {
    prsflgName() {
      if (this.project.prsflg == "2") {
        return "中标";
      } else if (this.project.prsflg == "1" || this.project.prsflg == "3") {
        return "成交";
      } else if (this.project.prsflg == "4" || this.project.prsflg == "5") {
        return "竞拍";
      }
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.psuid = this.$route.params.psuid;
      this.project = {};
      this.editorCGNR = "";
      this.editorCGNRContent = "";
    },
    async getProject() {
      this.loading = true;
      let obj = {};
      obj.psuid = this.$route.params.psuid;
      obj.selectField = ` b.projectcode,b.projectname,b.projectid,psuamt,psuid,psupricerate,prsflg,projectcosid,psubcncontent, projectatel,projectptel`;
      let res = await request({
        method: "get",
        url: "/xmgl/project/getpsubyid_onDemand",
        params: obj,
      });
      this.project = res[0];
      this.project.psuamt_tran = utils.comdify(this.project.psuamt);
      this.project.psuamt_bigwriht = utils.smallToBig(this.project.psuamt);
      this.editorCGNRContent = this.project.psubcncontent;
      this.loading = false;
    },
    async initEditorCGNR() {
      if (this.editorCGNR && this.project.psubcncontent) {
        this.editorCGNR.txt.html(this.project.psubcncontent);
        return;
      }
      this.editorCGNR = new E(this.$refs.editorCGNR);
      this.editorCGNR.config.onchange = (html) => {
        this.editorCGNRContent = html;
      };
      this.editorCGNR.config.uploadFileName = "file";
      this.editorCGNR.config.uploadImgServer = `${config.baseUrl}upload/upload`;
      this.editorCGNR.config.zIndex = 1;
      this.editorCGNR.create();
      if (this.project.psubcncontent) {
        this.editorCGNR.txt.html(this.project.psubcncontent);
      }
    },
    async saveWinningBid() {
      if (!this.editorCGNRContent) {
        this.$message.warning("请填写完内容后再保存");
        return;
      }
      let form = {};
      form.projectid = this.project.projectid;
      form.psuid = this.project.psuid;
      form.psubcncontent = this.editorCGNRContent;
      form.psubcnuserid = "";
      form.type = 1;
      let data = await request({
        url: "/xmgl/project/saveWinningBid",
        method: "post",
        data: form,
      });

      if (data.issuccess === 1) {
        this.$message.success("保存成功");
        return;
      }
    },
    viewWinningBid() {
      let { href } = this.$router.resolve({
        name: "pjBiddingNotice",
        query: { psuid: this.project.psuid, projectid: this.project.projectid },
      });
      window.open(href, "_blank");
    },
    async WinningBid() {
      if (!this.editorCGNRContent) {
        this.$message.warning("请填写完内容后再提交");
        return;
      }
      let form = {};
      form.projectid = this.project.projectid;
      form.psuid = this.project.psuid;
      form.psubcncontent = this.editorCGNRContent;
      form.type = 2;
      form.psubcnuserid = this.$store.getters.loginUser.userid;
      this.$confirm("是否确认提交", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let data = await request({
            url: "/xmgl/project/saveWinningBid",
            method: "post",
            data: form,
          });
          if (data.issuccess === 1) {
            this.close();
            this.$message.success("提交成功");
            return;
          }
        })
        .catch(() => {});
    },
    async close() {
      this.$store.commit("close_tab", {
        routeName: this.$route.name,
        vm: this,
        newRouteName: "womIndex",
      });
    },
    async setTmplContent() {
      if(!this.tmplchoose) return
      if (!this.editorCGNRContent) {
        await this.getTmplContent();
      } else {
        this.$confirm(
          `按模板生成通知书文本，将覆盖现有的通知书，是否继续？`,
          "提示",
          {
            confirmButtonText: "是",
            cancelButtonText: "否",
            type: "warning",
          }
        ).then(async () => {
          await this.getTmplContent();
        }).catch(()=>{
          this.tmplchoose = ""
        })
      }
    },
    async getTmplContent() {
      let model = {};
      model.selectField = `tmplcontent`;
      model.tmplid = this.tmplchoose;
      model.cosid = this.project.projectcosid;
      let res = await request({
        url: "/xmgl/tmpl/getTemplate",
        method: "get",
        params: model,
      });
      let tm = res.tmplcontent;
      let compiled = _.template(tm || "");
      let obj = this.project;
      console.log(obj)
      this.editorCGNRContent = compiled(obj);
      this.editorCGNR.txt.html(compiled(obj));
    },
    async getTemplateOptions() {
      let tmpltype = 4
      if (this.project.projectquotationmode === 3) {
        tmpltype = 7
      }
      this.templateOptions = await request({
        method: "get",
        url: "/xmgl/tmpl/getTemplateOptions",
        params: { tmplcosid: this.$store.getters.loginUser.cosid, tmpltype },
      });
    },
  },
};
</script>
<style lang="scss">
.btn-box {
  overflow: hidden;
  .vxe-button {
    padding: 10px 10px;
    font-size: 16px;
  }
}
.type {
  display: flex;
  align-items: center;
}
</style>
